import { observable, action, runInAction } from 'mobx';
import { isEmpty, cloneDeep, uniq } from 'lodash';

// import { locateValue } from '@tool/index';

const moFreshSalary = observable({
  type: 'chart', // chart, table
  tableHead: <any[]>[],
  tableList: <any[]>[],
  xData: <any[]>[],
  yData: <any[]>[],
  overview: <any[]>[],
  labels: <any[]>[],
});

const locateValue = (value: any) => {
  if (isNaN(value)) return '-';
  if (value === null || value === '' || value === undefined) return '-';
  if (value === 0) return '-';
  return Number(value).toLocaleString();
};

const initFreshSalary = action((res: any) => {
  const { type } = moFreshSalary;

  const tempType = localStorage.getItem('indicatorType5') || '';
  if (tempType && (tempType !== type)) moFreshSalary.type = tempType;
  else localStorage.setItem('indicatorType5', type);

  if (isEmpty(res)) return;

  moFreshSalary.tableHead = [
    { title: '行业' },
    {
      title: '大专',
      child: ['不区分'],
    },
    {
      title: '本科',
      child: ['不区分', '普通院校', '重点院校'],
    },
    {
      title: '硕士',
      child: ['不区分', '普通院校', '重点院校'],
    },
    {
      title: '博士',
      child: ['不区分', '普通院校', '重点院校'],
    },
  ];

  // console.log('~~~~~~ 行业应届生起薪 ~~~~~~ ', res);
  let xData: any[] = [];
  let yData: any[] = [];
  let overview: any[] = [];
  let labels: any[] = [];
  let tableList: any[] = [];

  res.overview?.map((item: any) => {
    let text = '';
    item?.map((child: any) => {
      text += child.value;
    });
    overview.push(text);
  });

  // 大专 associate
  // 本科 bachelor
  // 硕士 master
  // 博士 doctor
  let associateArr: any[] = [];
  let bachelorArr: any[] = [];
  let masterArr: any[] = [];
  let doctorArr: any[] = [];

  // 大专
  res.data?.map((item: any) => {
    xData.push(item.industry_lv2 || item.industry_lv1);
    associateArr.push(item.associate);
  });
  yData.push({ name: '大专', data: associateArr });

  // 本科
  res.data?.map((item: any) => {
    bachelorArr.push(item.bachelor);
  });
  yData.push({ name: '本科', data: bachelorArr });

  // 硕士
  res.data?.map((item: any) => {
    masterArr.push(item.master);
  });
  yData.push({ name: '硕士', data: masterArr });

  // 博士
  res.data?.map((item: any) => {
    doctorArr.push(item.doctor);
  });
  yData.push({ name: '博士', data: doctorArr });

  res.data?.map((item: any) => {
    let tempArr: any = [];
    xData.map((child: any) => {
      if (
        item.industry_lv2 === child || (item.industry_lv2 === '' && item.industry_lv1 === child)
      ) {
        tempArr.push(locateValue(item.associate));
        tempArr.push(locateValue(item.bachelor));
        tempArr.push(locateValue(item.bachelor_common));
        tempArr.push(locateValue(item.bachelor_key));
        tempArr.push(locateValue(item.master));
        tempArr.push(locateValue(item.master_common));
        tempArr.push(locateValue(item.master_key));
        tempArr.push(locateValue(item.doctor));
        tempArr.push(locateValue(item.doctor_common));
        tempArr.push(locateValue(item.doctor_key));
      }
    });
    tableList.push({
      title: item.industry_lv2 || item.industry_lv1,
      arr: tempArr,
    });
  });

  // console.log('table list === ', tableList);

  if (!isEmpty(res.total_industry_data)) {
    labels.push({
      value: res.total_industry_data?.associate,
      text: `${res.total_industry_data?.industry_lv1}大专起薪`,
    });
    labels.push({
      value: res.total_industry_data?.bachelor,
      text: `${res.total_industry_data?.industry_lv1}本科起薪`,
    });
    labels.push({
      value: res.total_industry_data?.master,
      text: `${res.total_industry_data?.industry_lv1}硕士起薪`,
    });
    labels.push({
      value: res.total_industry_data?.doctor,
      text: `${res.total_industry_data?.industry_lv1}博士起薪`,
    });
  }

  moFreshSalary.xData = xData;
  moFreshSalary.yData = yData;
  moFreshSalary.overview = overview;
  moFreshSalary.labels = labels;
  moFreshSalary.tableList = tableList;
});

const changeType = action((type: string) => {
  moFreshSalary.type = type;
  localStorage.setItem('indicatorType5', type);
});

export default moFreshSalary;
export {
  initFreshSalary, changeType,
};
